import React from 'react'
import usage1 from '../../../assets/imgs/host/usage01.png'
import usage1Dimension from '../../../assets/imgs/host/usage01.png?size'
import usage2 from '../../../assets/imgs/host/usage02.png'
import usage2Dimension from '../../../assets/imgs/host/usage02.png?size'
import usage3 from '../../../assets/imgs/host/usage03.png'
import usage3Dimension from '../../../assets/imgs/host/usage03.png?size'
import usage4 from '../../../assets/imgs/host/usage04.png'
import usage4Dimension from '../../../assets/imgs/host/usage04.png?size'
import ResponsiveImg from '../../common/ResponsiveImg'
import styles from './Usage.scss'
import {UrlPrefix} from '../../../config/constants'
import {useLocale} from '../../hocs/hooks'

const Usage = () => {
  const locale = useLocale()
  return <>
  <div className={styles.space120}/>
    <div className={styles.container}>
      <div className={[styles.titleRow].join(' ')}>
        <h2 className={['m-0', styles.title].join(' ')}>ホスト登録から<br className='d-block d-md-none'/>車中泊スポット・体験を<br className='d-block d-md-none'/>提供するまでの流れ</h2>
      </div>
      <div className={['d-md-flex', styles.petsRow].join(' ')}>
        <div className={[styles.voiceRow].join(' ')}>
          <div className={[styles.image].join(' ')}>
            <ResponsiveImg
              url={usage1}
              caption="usage1"
              srcSet={usage1}
              dimension={usage1Dimension}
            />
          </div>
          <div className={styles.mt40}>
            <h3 className={[styles.subTitle].join(' ')}><span className={styles.otherFont}>1.</span>ホスト登録</h3>
            <p className={['mb-0', styles.text].join(' ')}>
              必要事項の入力し、ホストの登録を完了しましょう。報酬振込のための口座情報の入力もお忘れなく。
            </p>
          </div>
        </div>
        <div className={[styles.voiceRow].join(' ')}>
          <div className={[styles.image].join(' ')}>
            <ResponsiveImg
              url={usage2}
              caption="usage2"
              srcSet={usage2}
              dimension={usage2Dimension}
            />
          </div>
          <div className={styles.mt40}>
            <h3 className={[styles.subTitle, styles.lh30].join(' ')}><span className={styles.otherFont}>2.</span>車中泊スポット・キャンプ場・体験を登録</h3>
            <p className={['mb-0', styles.text].join(' ')}>
              必要事項の入力を済ませ、登録申請をしましょう。Carstayでの認証後、ゲストからの予約を受付できます。
            </p>
          </div>
        </div>
        <div className={[styles.voiceRow].join(' ')}>
          <div className={[styles.image].join(' ')}>
            <ResponsiveImg
              url={usage3}
              caption="usage3"
              srcSet={usage3}
              dimension={usage3Dimension}
            />
          </div>
          <div className={styles.mt40}>
            <h3 className={[styles.subTitle].join(' ')}><span className={styles.otherFont}>3.</span>当日ゲストを迎える</h3>
            <p className={['mb-0', styles.text].join(' ')}>
              当日はCarstay専用のロードコーンを設置し、ゲストを迎えましょう。必要に応じて、受付や施設の説明、体験のご案内をしましょう
            </p>
          </div>
        </div>
        <div className={[styles.voiceRow].join(' ')}>
          <div className={[styles.image].join(' ')}>
            <ResponsiveImg
              url={usage4}
              caption="usage4"
              srcSet={usage4}
              dimension={usage4Dimension}
            />
          </div>
          <div className={styles.mt40}>
            <h3 className={[styles.subTitle].join(' ')}><span className={styles.otherFont}>4.</span>報酬を受け取る</h3>
            <p className={['mb-0', styles.text].join(' ')}>
              チェックアウトの完了と同時に報酬が確定します。<br />
              報酬の合計が一定額に達すると、手数料を差し引いた報酬が翌月末に振り込まれます。※詳細は
              <a href={`/${locale}${UrlPrefix.host}/#qa`}>こちら</a>
            </p>
          </div>
      </div>
    </div>
  </div>
 <div className={styles.space120}/>
 </>
}
Usage.displayName = 'Usage'
export default Usage
